import Emojis from './emojis';

export const customEmoji = [
    { image: Emojis.B, keyCode: ':b:' },
    { image: Emojis.I, keyCode: ':i:' },
    { image: Emojis.N, keyCode: ':n:' },
    { image: Emojis.G, keyCode: ':g:' },
    { image: Emojis.O, keyCode: ':o:' },
    { image: Emojis.HardLaugh, keyCode: ':0' },
    { image: Emojis.Angry, keyCode: ':@' },
    { image: Emojis.BrokenHeart, keyCode: '(u)' },
    { image: Emojis.Confused, keyCode: ':s' },
    { image: Emojis.Devious, keyCode: ';d' },
    { image: Emojis.Embarrased, keyCode: ':$' },
    { image: Emojis.Geek, keyCode: '8-|' },
    { image: Emojis.Guilty, keyCode: ':#' },
    { image: Emojis.Happy, keyCode: ':)' },
    { image: Emojis.InLove, keyCode: 'x-)' },
    { image: Emojis.Kiss, keyCode: '(k)' },
    { image: Emojis.Lunch, keyCode: '(pi)' },
    { image: Emojis.PalmTree, keyCode: '(ip)' },
    { image: Emojis.Sarcastic, keyCode: ';s' },
    { image: Emojis.Sick, keyCode: '+o(' },
    { image: Emojis.Surprised, keyCode: ':-o' },
    { image: Emojis.Tongue, keyCode: ':p' },
    { image: Emojis.VeryAngry, keyCode: 'x@' },
    { image: Emojis.VeryHappy, keyCode: '|d' },
    { image: Emojis.Wink, keyCode: ';)' },
    { image: Emojis.Wondering, keyCode: ':?' },
    { image: Emojis.Worried, keyCode: ':/' },
    { image: Emojis.cake, keyCode: '(^)' },
    { image: Emojis.clock, keyCode: '(c)' },
    { image: Emojis.cool, keyCode: '(h)' },
    { image: Emojis.crying, keyCode: '(cry)' },
    { image: Emojis.devil, keyCode: '(6)' },
    { image: Emojis.flower, keyCode: '(f)' },
    { image: Emojis.heart, keyCode: '(l)' },
    { image: Emojis.moon, keyCode: '(s)' },
    { image: Emojis.present, keyCode: '(gi)' },
    { image: Emojis.star, keyCode: '(*)' },
    { image: Emojis.sun, keyCode: '(#)' },
];

export const CUSTOM_EMOJI_MAP = customEmoji.reduce(
    (result, { image, keyCode }) => {
        result[keyCode] = image;
        return result;
    },
    {} as Record<string, string>
);

export const BINGO_EMOJIS = {
    id: 'bingo',
    name: 'Bingo',
    emojis: [
        {
            id: 'b',
            name: 'B',
            keywords: ['(b)', 'bingo', 'ball', 'B'],
            skins: [
                {
                    src: Emojis.B,
                },
            ],
        },
        {
            id: 'i',
            name: 'I',
            keywords: ['(i)', 'bingo', 'ball', 'I'],
            skins: [
                {
                    src: Emojis.I,
                },
            ],
        },
        {
            id: 'n',
            name: 'N',
            keywords: ['(n)', 'bingo', 'ball', 'N'],
            skins: [
                {
                    src: Emojis.N,
                },
            ],
        },
        {
            id: 'g',
            name: 'G',
            keywords: ['(g)', 'bingo', 'ball', 'G'],
            skins: [
                {
                    src: Emojis.G,
                },
            ],
        },
        {
            id: 'o',
            name: 'O',
            keywords: ['(o)', 'bingo', 'ball', 'O'],
            skins: [
                {
                    src: Emojis.O,
                },
            ],
        },
    ],
};

export const CLASSIC_EMOJIS = {
    id: 'classic',
    name: 'Classic',
    emojis: [
        {
            id: ':0',
            name: 'Hard Laugh',
            keywords: ['HardLaugh'],
            skins: [
                {
                    src: Emojis.HardLaugh,
                },
            ],
        },
        {
            id: ':@',
            name: 'Angry',
            keywords: ['Angry'],
            skins: [
                {
                    src: Emojis.Angry,
                },
            ],
        },
        {
            id: '(u)',
            name: 'Broken Heart',
            keywords: ['BrokenHeart'],
            skins: [
                {
                    src: Emojis.BrokenHeart,
                },
            ],
        },
        {
            id: ':s',
            name: 'Confused',
            keywords: ['Confused'],
            skins: [
                {
                    src: Emojis.Confused,
                },
            ],
        },
        {
            id: ';d',
            name: 'Devious',
            keywords: ['Devious'],
            skins: [
                {
                    src: Emojis.Devious,
                },
            ],
        },
        {
            id: ':$',
            name: 'Embarrased',
            keywords: ['Embarrased'],
            skins: [
                {
                    src: Emojis.Embarrased,
                },
            ],
        },
        {
            id: '8-|',
            name: 'Geek',
            keywords: ['Geek'],
            skins: [
                {
                    src: Emojis.Geek,
                },
            ],
        },
        {
            id: ':#',
            name: 'Guilty',
            keywords: ['Guilty'],
            skins: [
                {
                    src: Emojis.Guilty,
                },
            ],
        },
        {
            id: ':)',
            name: 'Happy',
            keywords: ['Happy'],
            skins: [
                {
                    src: Emojis.Happy,
                },
            ],
        },
        {
            id: 'x-)',
            name: 'In Love',
            keywords: ['InLove'],
            skins: [
                {
                    src: Emojis.InLove,
                },
            ],
        },
        {
            id: '(k)',
            name: 'Kiss',
            keywords: ['Kiss'],
            skins: [
                {
                    src: Emojis.Kiss,
                },
            ],
        },
        {
            id: '(pi)',
            name: 'Lunch',
            keywords: ['Lunch'],
            skins: [
                {
                    src: Emojis.Lunch,
                },
            ],
        },
        {
            id: '(ip)',
            name: 'Palm Tree',
            keywords: ['PalmTree'],
            skins: [
                {
                    src: Emojis.PalmTree,
                },
            ],
        },
        {
            id: ';s',
            name: 'Sarcastic',
            keywords: ['Sarcastic'],
            skins: [
                {
                    src: Emojis.Sarcastic,
                },
            ],
        },
        {
            id: '+o(',
            name: 'Sick',
            keywords: ['Sick'],
            skins: [
                {
                    src: Emojis.Sick,
                },
            ],
        },
        {
            id: ':-o',
            name: 'Surprised',
            keywords: ['Surprised'],
            skins: [
                {
                    src: Emojis.Surprised,
                },
            ],
        },
        {
            id: ':p',
            name: 'Tongue',
            keywords: ['Tongue'],
            skins: [
                {
                    src: Emojis.Tongue,
                },
            ],
        },
        {
            id: 'x@',
            name: 'Very Angry',
            keywords: ['VeryAngry'],
            skins: [
                {
                    src: Emojis.VeryAngry,
                },
            ],
        },
        {
            id: '|d',
            name: 'Very Happy',
            keywords: ['VeryHappy'],
            skins: [
                {
                    src: Emojis.VeryHappy,
                },
            ],
        },
        {
            id: ';)',
            name: 'Wink',
            keywords: ['Wink'],
            skins: [
                {
                    src: Emojis.Wink,
                },
            ],
        },
        {
            id: ':?',
            name: 'Wondering',
            keywords: ['Wondering'],
            skins: [
                {
                    src: Emojis.Wondering,
                },
            ],
        },
        {
            id: ':/',
            name: 'Worried',
            keywords: ['Worried'],
            skins: [
                {
                    src: Emojis.Worried,
                },
            ],
        },
        {
            id: '(^)',
            name: 'Cake',
            keywords: ['cake'],
            skins: [
                {
                    src: Emojis.cake,
                },
            ],
        },
        {
            id: '(c)',
            name: 'Clock',
            keywords: ['clock'],
            skins: [
                {
                    src: Emojis.clock,
                },
            ],
        },
        {
            id: '(h)',
            name: 'Cool',
            keywords: ['cool'],
            skins: [
                {
                    src: Emojis.cool,
                },
            ],
        },
        {
            id: '(cry)',
            name: 'Crying',
            keywords: ['crying'],
            skins: [
                {
                    src: Emojis.crying,
                },
            ],
        },
        {
            id: '(6)',
            name: 'Devil',
            keywords: ['devil'],
            skins: [
                {
                    src: Emojis.devil,
                },
            ],
        },
        {
            id: '(f)',
            name: 'Flower',
            keywords: ['flower'],
            skins: [
                {
                    src: Emojis.flower,
                },
            ],
        },
        {
            id: '(l)',
            name: 'Heart',
            keywords: ['heart'],
            skins: [
                {
                    src: Emojis.heart,
                },
            ],
        },
        {
            id: '(s)',
            name: 'Moon',
            keywords: ['moon'],
            skins: [
                {
                    src: Emojis.moon,
                },
            ],
        },
        {
            id: '(gi)',
            name: 'Present',
            keywords: ['present'],
            skins: [
                {
                    src: Emojis.present,
                },
            ],
        },
        {
            id: '(*)',
            name: 'Star',
            keywords: ['star'],
            skins: [
                {
                    src: Emojis.star,
                },
            ],
        },
        {
            id: '(#)',
            name: 'Sun',
            keywords: ['sun'],
            skins: [
                {
                    src: Emojis.sun,
                },
            ],
        },
    ],
};

export const customEmojiData = [BINGO_EMOJIS, CLASSIC_EMOJIS];

export const CLASSIC_SHORT_CODES = CLASSIC_EMOJIS.emojis.reduce(
    (result, emoji) => {
        result[`:${emoji.id}:`] = emoji.id;
        return result;
    },
    {} as Record<string, string>
);

export const parseClassicShortCodes = (shortCode: string) =>
    CLASSIC_SHORT_CODES[shortCode as keyof typeof CLASSIC_EMOJIS] || shortCode;
